module.exports = "https://www.gc-pro.gnp.com.mx/c1afceae4b654843b1514016b20556ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/boton/09.png
// module id = 1012
// module chunks = 0 1